import { useContext, useState, useEffect } from "react";
import { ReactComponent as Plus } from "../../assets/newImages/icons/plus.svg";
import { FloatingButtonContainer } from "./styles";
import { ScrollDirectionContext } from "../../contexts/ScrollDirection/ScrollDirectionContext";
import { Link } from "react-router-dom";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { ReactComponent as OptionsSVG } from "../../assets/newImages/icons/options.svg";
import LockedIcon from "../LockedIcon/LockedIcon";

interface FloatingButtonProps {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>) => void;
  className?: string;
  target?: string;
  href?: string;
  subButton?: boolean;
  onClickSubButton?: (e: React.MouseEvent<HTMLDivElement>) => void;
  disabled?: boolean;
  lockedMessage?: string;
}

const FloatingButton: React.FC<FloatingButtonProps> = ({
  onClick,
  className,
  href,
  target,
  subButton,
  onClickSubButton,
  disabled,
  lockedMessage,
}) => {
  const scrollDir = useContext(ScrollDirectionContext).direction;
  const { theme } = useTheme();
  const [showText, setShowText] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowText(false);
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <FloatingButtonContainer
        theme={theme}
        className={`${scrollDir === "up" && "floating-ativo"} ${
          className && className.toString()
        } ${disabled ? 'disabled' : ''} ${!showText ? 'collapsed' : ''}`}
      >
        {subButton && (
          <div
            className="seletor-mobile"
            onClick={onClickSubButton ? onClickSubButton : () => {}}
          >
            <OptionsSVG className="icone-floating" />
          </div>
        )}
        {href && !disabled ? (
          <Link
            to={href}
            target={target}
            className={`mais fonteTexto`}
            onClick={onClick}
          >
            <Plus className="icone-floating" />
            {showText && "Cadastrar"}
          </Link>
        ) : (
          <div
            className={``}
            onClick={!disabled ? onClick : undefined}
          >
            {disabled ? (
              <LockedIcon className="locked" width="2.4rem" mensagem={lockedMessage} />
            ) : (
              <div className="mais fonteTexto">
                <Plus className="icone-floating" />
                {showText && "Cadastrar"}
              </div>
            )}
          </div>
        )}
      </FloatingButtonContainer>
    </>
  );
};

export default FloatingButton;